import React from 'react'
import NavbarContent from '../components/Navbar/navbar';
import AboutContent from '../components/About/about';


export default function About() {
  return (
    <div>
     <NavbarContent/>
     <AboutContent/>
    </div>
  );
}

